import { useAuth } from '../../../../hooks/auth/use-auth';
import { clearStorageData } from '../../../../utils/storage/storage';

export const useLogoutLavva = () => {
  const { keycloak } = useAuth();

  const handleLogoutLavva = () => {
    clearStorageData();
    keycloak.logout();
  };

  return {
    handleLogoutLavva,
  };
};
